export default __webpack_public_path__ + "0abab4cd846c3996d25f0e5179ff9c4a.svg";